import { util, dia } from '@joint/core';

export const Choreography = dia.Element.define('bpmn2.Choregraphy', {

    type: 'bpmn2.Choreography',
    size: {
        width: 100,
        height: 120
    },
    attrs: {
        root: {
            cursor: 'move'
        },
        body: {
            width: 'calc(w)',
            height: 'calc(h)',
            strokeWidth: 2,
            stroke: '#333333',
            fill: '#ffffff'
        },
        fo: {
            width: 'calc(w)',
            height: 'calc(h)',
        },
        participants: {
            participantY: true,
        },
        participantsBodies: {
            width: 'calc(w)',
            height: 20,
            strokeWidth: 2,
            stroke: '#333333',
            fill: '#aaaaaa'
        },
        participantsLabels: {
            x: 'calc(w / 2)',
            y: 10,
            textAnchor: 'middle',
            dominantBaseline: 'central',
            fontSize: 12,
            fontFamily: 'sans-serif'
        },
        initiatingParticipantBody: {
            fill: 'transparent',
        },
        content: {
            contentAlignment: true,
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
                display: 'table-cell',
                fontFamily: 'sans-serif',
            },
            html: '',
        },
        subProcess: {
            d: 'M -8 -20 H 8 V -4 H -8 Z M -6 -12 H 6 M 0 -18 V -6',
            fill: 'transparent',
            transform: 'translate(calc(w / 2), 0)',
            subProcessY: true,
            stroke: '#000000',
            strokeWidth: 2,
        }
    },

    subProcess: false,
    participants: [],
    participantHeight: 20,
    initiatingParticipant: 0 // index (number) or participant name (string)

}, {

    markup: [{
        tagName: 'rect',
        selector: 'body'
    }, {
        tagName: 'foreignObject',
        selector: 'fo',
        children: [{
            tagName: 'div',
            selector: 'content',
            namespaceURI: 'http://www.w3.org/1999/xhtml',
        }]
    }, {
        tagName: 'text',
        selector: 'label'
    }],

    markupAttributes: [
        'participants',
        'initiatingParticipant',
        'subProcess',
    ],

    initialize: function() {
        dia.Element.prototype.initialize.apply(this, arguments);
        this.on('change', (_, opt) => this.onChange(opt));
        this.buildMarkup();
    },

    anyHasChanged: function(attributes) {
        if (!Array.isArray(attributes)) return false;
        return attributes.some(function(attrName) {
            return this.hasChanged(attrName);
        }, this);
    },

    onChange: function(opt) {
        if (opt.choreography !== this.id && this.hasChanged('markup')) {
            throw new Error('bpmn2.Choreography: Markup can not be modified.');
        }
        if (this.anyHasChanged(this.markupAttributes)) this.buildMarkup(opt);
    },

    buildParticipantMarkup: function(id, label, initiating) {

        const markup = {
            tagName: 'g',
            groupSelector: 'participants',
            attributes: {
                'participant-id': id,
            }
        };

        const bodyMarkup = {
            tagName: 'rect',
            groupSelector: 'participantsBodies',
        };

        const labelMarkup = {
            tagName: 'text',
            groupSelector: 'participantsLabels',
            textContent: label
        };

        if (initiating) {
            markup.selector = 'initiatingParticipant';
            bodyMarkup.selector = 'initiatingParticipantBody';
            labelMarkup.selector = 'initiatingParticipantLabel';
        }

        markup.children = [bodyMarkup, labelMarkup];
        return markup;
    },

    buildSubProcessMarkup: function() {
        return {
            tagName: 'path',
            selector: 'subProcess',
        };
    },

    buildMarkup: function(opt) {

        const { initiatingParticipantIndex, participants } = this;
        const participantsMarkup = participants.map((participant, index) => {
            const id = (index > initiatingParticipantIndex) ? -(participants.length - index) : index;
            return this.buildParticipantMarkup(id, participant, index === initiatingParticipantIndex);
        });

        const markup = this.markup.concat(
            ...participantsMarkup
        );

        if (this.get('subProcess')) {
            markup.push(this.buildSubProcessMarkup());
        }

        const flags = util.assign({ choreography: this.id, dry: true }, opt);
        this.set('markup', markup, flags);
    }

}, {
    attributes: {
        'participant-y': {
            position(_, refBBox, node) {
                const { participantHeight } = this.model;
                const id = parseInt(node.getAttribute('participant-id'), 10);
                const y = (id < 0) ? refBBox.height + id * participantHeight : id * participantHeight;
                return { x: 0, y };
            }
        },
        'sub-process-y': {
            position(_, refBBox, node) {
                const { participantHeight, participants, initiatingParticipantIndex } = this.model;
                const paddingTop = participantHeight * (participants.length - initiatingParticipantIndex - 1);
                return { x: 0, y: refBBox.height - paddingTop };
            }
        },
        'content-alignment': {
            set(_, refBBox, node) {
                const { participantHeight, participants, initiatingParticipantIndex } = this.model;
                const paddingTop = participantHeight * (initiatingParticipantIndex + 1);
                node.style.paddingTop = `${paddingTop}px`;
                node.style.height = `${refBBox.height - participants.length * participantHeight}px`;
                node.style.width = `${refBBox.width}px`;
            }
        }
    }
});

Object.defineProperty(Choreography.prototype, 'participants', {
    get() {
        const participants = this.get('participants');
        if (Array.isArray(participants)) {
            return participants;
        }
        return [];
    }
});

Object.defineProperty(Choreography.prototype, 'initiatingParticipantIndex', {
    get() {
        const initiatingParticipant = this.get('initiatingParticipant');
        if (Number.isFinite(initiatingParticipant)) {
            return initiatingParticipant;
        }
        return this.participants.indexOf(initiatingParticipant);
    }
});

Object.defineProperty(Choreography.prototype, 'participantHeight', {
    get() {
        const height = this.get('participantHeight');
        if (Number.isFinite(height)) {
            return height;
        }
        return 20;
    }
});
